import "./../style/Projects.scss";
import Project from "./Project";
import { projects } from "../data/projects";

function Projects({ projectsRef, onSelectProject }) {
  return (
    <div className="projectsSection" id="projects" ref={projectsRef}>
      <h1 className="projectsTitle">
        Projects
      </h1>
      <div className="projectsContainer">
        {projects.map((project) => (
          <Project key={project.slug} project={project} onSelect={onSelectProject} />
        ))}
      </div>
    </div>
  );
}

export default Projects;
